import { Component, OnInit, ViewChild, TemplateRef, Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Seguimiento_certificado } from '../../models/seguimiento_certificado.model';
//import { MatDialog, MatSnackBar, MatPaginator, MatSort, PageEvent, MatTableDataSource, Sort, MatStepper } from '@angular/material';

import { MatDialog, MatSnackBar } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { PerfilComponent } from './../perfil/perfil.component';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Router, ActivatedRoute, Params } from '@angular/router'
import { format } from 'util';
import { NgxSpinnerService } from 'ngx-spinner';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Seguimiento_cert_Service } from 'src/app/services/seguimiento_cert.service';
import { Solicitante_certificado } from 'src/app/models/solicitante_certificado.model';


declare var jQuery: any;
declare var $: any;
/*
export interface seg_elements {
    //rut: string;
    num_solicitud: string;
}
*/

@Component({
    selector: "page-seguimiento_certificado",
    templateUrl: "./seguimiento_certificado.component.html",
    styleUrls: ["./seguimiento_certificado.component.css"],
    providers: [UserService, FormService, Seguimiento_cert_Service]
})

export class Seguimiento_certificadoComponent {
    @ViewChild('openModalCert') openModalCert: TemplateRef<any>;
    @ViewChild('openModal') openModal: TemplateRef<any>;


    displayedColumns: string[] = ['solicitud', 'tipo', 'descripcion', 'detalle'];
    public dataSource: MatTableDataSource<Solicitante_certificado>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    /*@ViewChild('stepper') stepper: MatStepper
    isLinear = true;
    isEditable = false;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    */
    public solicitudes;
    public seguim_cert: Seguimiento_certificado;
    public solicitante: Solicitante_certificado;




    public searchText
    public temp_dir = "a";
    public isopen = false;
    matcher = new FormService();
    //public licitaciones = [];
    public rows = [];
    public actualRow;
    public seguim_certif = [];
    public panelobs;
    public observ;
    public isDisabled;


    public p: number = 1;


    public arquitecto = false;
    public rechazada = false;
    public estatus = false;
    public titulo;
    public estatus_aprob = false
    public fechaacta = false
    public colorobserv;
    public obser;
    public estadocolor
    public letracolor
    public fechavisita
    public fechacolor
    public estadofecha
    public arquit;
    public colorarquit;
    public fechareingreso = false
    public aprobacion = false
    public aprobcolor
    public aprobletracolor
    public rut_solic;
    public informacion;
    public rut;
    public length;
    public pageSize;
    public pageSizeOptions: number[] = [5, 10, 25, 100];
    /* pageEvent: PageEvent;*/
    public idSolicitud = new FormControl('', Validators.compose([Validators.required, Validators.pattern('[0-9]+')]));

    //solicitud
    public sol_encontrada
    public idEncontrado = false
    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _formBuilder: FormBuilder,
        private _userService: UserService,
        private spinner: NgxSpinnerService,
        private dialog: MatDialog,
        private _formService: FormService,
        public _certService: Seguimiento_cert_Service,
        private snackBar: MatSnackBar,
        private _cd: ChangeDetectorRef,
        private _snackBar: MatSnackBar) {

        this.seguim_cert = { num_solicitud: '', rol: '', tipo: '', direccion: '', fecha_ingreso: null, estado: '', descripcion: '', recordId: '', estado_web: '' };


        //this.informacion = JSON.parse(sessionStorage.getItem("identity-domCloud"));
        //this.rut_solic = this.informacion.rut + "-" + this.informacion.dv;
        //this.rut = this.rut_solic;

        if (!JSON.parse(localStorage.getItem("solicitud_cert"))) {
            localStorage.setItem("solicitud_cert", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("solicitud_cert"));
        }
        // this.get_solicitudes();

        registerLocaleData(es)
    }
    ngOnInit() {
        console.log('init!!');
        //this.get_solicitudes(this.rut_solic);
       // this.dialog.open(this.openModal);

    }


    getCleanedString(cadena) {
        // Definimos los caracteres que queremos eliminar
        let specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";

        // Los eliminamos todos
        for (let i = 0; i < specialChars.length; i++) {
            cadena = cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
        }
        // Lo queremos devolver limpio en mayuscula
        cadena = cadena.toLowerCase();
        // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
        // cadena = cadena.replace(/ /g,"_");
        // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
        cadena = cadena.replace(/á/gi, "a");
        cadena = cadena.replace(/é/gi, "e");
        cadena = cadena.replace(/í/gi, "i");
        cadena = cadena.replace(/ó/gi, "o");
        cadena = cadena.replace(/ú/gi, "u");
        cadena = cadena.replace(/ñ/gi, "n");
        cadena = cadena.toUpperCase();
        return cadena;
    }

    getSolicitud() {

        this._certService.getSolicitud(this.idSolicitud.value).subscribe(response => {
            if (response.exist) {
                this.sol_encontrada = {
                    id: response.sol['Tramite_Solicitudes::_TRA_ID'],
                    rut: response.sol['Adm_Solicitantes::Sol_RUTDV'],
                    tipo: response.sol['TRACER_Tipo_Solicitud_Completo'],
                    estado: response.sol['Tramite_Solicitudes::TRA_Estado_cert_web_descripcion'],
                    fecha_final: response.sol['TRACER_Fecha_Final'],
                    ingresoCAS: response.sol['TRACER_Ingreso_CAS'],
                    fecha_ingreso: response.sol['Tramite_Solicitudes::TRA_Fecha_Creacion'],
                    dir: response.sol['Tramite_Solicitudes::TRA_Pro_Direccion'],
                    rol: response.sol['Tramite_Solicitudes::TRA_Pro_Rol_Imprimir']
                }
                this.idEncontrado = true
                this._cd.detectChanges();
            } else {
                this._snackBar.open(response.message, 'Cerrar', {
                    duration: 3000,
                });
            }
            

        }, error => {
            var err = JSON.parse(error._body)
            this._snackBar.open(err.message, 'Cerrar', {
                duration: 3000,
            });

            console.log(error)
        })
    }

    // get_solicitudes() {

    //     this.spinner.show()
    //     this._expService.getSolicitud().subscribe(
    //         response => {
    //             console.log('1');
    //             //this.firstFormGroup.controls['rut'].setValue('');
    //            // this.firstFormGroup.controls['num_solicitud'].setValue('');	
    //             if (response.message) {
    //                 this.cleanData();
    //                 //this.dialog.open(this.openModal);
    //                 alert("El Rut que estas buscando no existe en los registros");
    //                 this.spinner.hide();
    //             } else {
    //                 console.log("quiere mostrar los certificados...")

    //                 /*this.stepper.next();
    //                 this.seguim_cert.num_solicitud = response.num_solicitud ? response.num_solicitud : '';
    //                 this.seguim_cert.rol = response.rol ? response.rol : '';
    //                 this.seguim_cert.tipo = response.tipo ? response.tipo : '';
    //                 this.seguim_cert.direccion = response.direccion ? response.direccion : '';
    //                 this.seguim_cert.fecha_ingreso = response.fecha_ingreso ? response.fecha_ingreso : '';
    //                 this.seguim_cert.estado = response.estado ? response.estado : '';
    //                 this.seguim_cert.descripcion = response.descripcion ? response.descripcion : '';
    //                 */
    //                 /*
    //                 this.solicitudes = response.solicitudes;
    //                 console.log('en ts...');
    //                 console.table(this.solicitudes);
    //                 this.dataSource = this.solicitudes;
    //                 this.length = this.solicitudes.length;
    //                 //console.log ("Length "+this.length);
    //                 this.pageSize = "5";
    //                 this.pageSizeOptions = [5, 10, 25, 100];
    //                 this.dataSource.paginator = this.paginator;
    //                 this.dataSource.sort = this.sort;
    //                 */
    //                this.solicitudes = response.solicitudes;
    //                //this.dataSource = this.solicitudes;
    //                this.dataSource = new MatTableDataSource(this.solicitudes);
    //                setTimeout(() => this.dataSource.paginator = this.paginator )
    //                 this.dataSource.sort = this.sort;
    //                 this.spinner.hide();
    //                 //this.isLinear = true
    //             }
    //         },
    //         error => {
    //             console.log('2');
    //             console.log(error)
    //             this.spinner.hide();
    //         }
    //     )
    // }



    // get_solicitud(sol) {
    //     //  this.cleanData();

    //     //console.table(sol);
    //     console.log("RUT PRUEBA" + this.rut_solic)
    //     console.log("NUMSOL " + sol.num_solicitud)
    //     //var num_solicitud = sol.num_solicitud;
    //     // let num_solicitud = numero;
    //     this.spinner.show()
    //     this._expService.getCert(this.rut_solic, sol.num_solicitud).subscribe(
    //         response => {
    //             console.log(response);
    //             if (response.message) {
    //                 this.cleanData();
    //                 alert("El número de solicitud que estas buscando no existe en los registros");
    //                 this.spinner.hide();
    //             } else {

    //                 this.seguim_cert.num_solicitud = response.informacion.num_solicitud ? response.informacion.num_solicitud : '';
    //                 this.seguim_cert.rol = response.informacion.rol ? response.informacion.rol : '';
    //                 this.seguim_cert.tipo = response.informacion.tipo ? response.informacion.tipo : '';
    //                 this.seguim_cert.direccion = response.informacion.direccion ? response.informacion.direccion : '';
    //                 this.seguim_cert.fecha_ingreso = response.informacion.fecha_ingreso ? response.informacion.fecha_ingreso : '';
    //                 this.seguim_cert.estado = response.informacion.estado ? response.informacion.estado : '';
    //                 this.seguim_cert.descripcion = response.informacion.descripcion ? response.informacion.descripcion : '';
    //                 this.seguim_cert.estado_web = response.informacion.estado_web ? response.informacion.estado_web : '';
    //                 this.spinner.hide()
    //                 this.dialog.open(this.openModalCert);
    //             }


    //         },
    //         error => {
    //             console.log(error)
    //             this.spinner.hide();
    //         }
    //     )
    // }
    /*
    ngDoCheck() {
        this.dataSource.paginator = this.paginator;
        //  this.lSolicitud = this.firstFormGroup.get('num_solicitud').value;
    }
    */
    cleanData() {
        this.seguim_cert = { num_solicitud: '', rol: '', tipo: '', direccion: '', fecha_ingreso: null, estado: '', descripcion: '', recordId: '', estado_web: '' };
    }

    inicio() {
        this._router.navigate(['/']);
    }

    perfil() {
        this.dialog.open(PerfilComponent)
    }

    compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    /*
    sortData(sort: Sort) {
        const data = this.solicitudes.slice();
        if (!sort.active || sort.direction === '') {
            this.dataSource = data;
            this.dataSource.paginator = this.paginator;
        
            return;
        }

        this.dataSource = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'solicitud': return this.compare(a.num_solicitud, b.num_solicitud, isAsc);
                case 'rol': return this.compare(a.rol, b.rol, isAsc);
                case 'tipo': return this.compare(a.tipo, b.tipo, isAsc);
                case 'direccion': return this.compare(a.direccion, b.direccion, isAsc);
                case 'fecha_ingreso': return this.compare(a.fecha_ingreso, b.fecha_ingreso, isAsc);
                case 'estado': return this.compare(a.estado, b.estado, isAsc);
                default: return 0;
            }
           
        });
    }
    */
    /*
     pageEvento(event){
         //it will run everytime you change paginator
             this.dataSource.paginator = this.paginator;
          }
          
   
          */
    logout() {
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");
        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
        this._router.navigate(['/inicio']);
    }
}